import { useAppSelector } from '@/hooks/useAppSelector';

const EMPTY_OPTIONS: import('@/api/masterData.api').MasterOption[] = [];

/** Global reference data from session init — replaces GET /v1/master-data/all per page. */
export function useMasterData() {
  const referenceData = useAppSelector((s) => s.session.referenceData);
  const loading = useAppSelector((s) => s.session.loading && !s.session.loaded);
  const loaded = useAppSelector((s) => s.session.loaded);

  return {
    loading: loading || (!loaded && !referenceData),
    countries: referenceData?.countries ?? EMPTY_OPTIONS,
    currencies: referenceData?.currencies ?? EMPTY_OPTIONS,
    timezones: referenceData?.timezones ?? EMPTY_OPTIONS,
    taxModes: referenceData?.taxModes ?? EMPTY_OPTIONS,
  };
}
